import { Component, EventEmitter, Output } from '@angular/core';
import { UploadService } from '../../services/upload/upload.service';
import { MAmzone } from '@argalis-apps/models';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'lib-ags-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
  animations: [
    trigger('alertDisplay', [
      transition(':enter', [
        style({ transform: 'scale(0.8)', opacity: '0', height: '0' }),
        animate(100, style({ height: '100%' })),
        animate(300, style({ transform: 'scale(1)', opacity: '1' }))
      ]),
      transition(':leave', [
        animate(300, style({ transform: 'scale(0.5)', opacity: '0' })),
        animate(100, style({ height: '0' }))
      ])
    ])
  ]
})
export class UploadFileComponent {
  public files: File[] = [];
  public loading = false;
  public tooBig = false;
  errorServer = false;
  public dropZoneHtmlElm = `<div class="dropZoneElement center-align">
            Déposez le(s) fichier(s) ici
             <i class="material-icons valign">file_download</i>
    </div>`;

  @Output() amzoneInfo = new EventEmitter<MAmzone.IAmazoneUploadReponse>();
  @Output() fileName = new EventEmitter<string>();
  constructor(private uploadService: UploadService) {}

  onSelect(event) {
    this.loading = true;
    this.tooBig = false;
    this.files.push(...event.addedFiles);
    if (!this.files.length) {
      this.tooBig = true;
      this.loading = false;
      return;
    }
    this.uploadService.uploadFile(this.files[0]).subscribe(
      res => {
        this.fileName.emit(event.addedFiles[0].name);
        this.amzoneInfo.emit(res);
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }
}
